import type { PmsReportFormat, PmsReportId } from '@felix/domain';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { PmsReportFilter, PmsSource } from './source.js';

/**
 * Raporun Excel ya da CSV dışa aktarması (plan M7 Task 29): dosya sunucuda üretilir, dili
 * arayüzün dilidir. Kaynak dışa aktarmayı bilmiyorsa `available` yanlıştır (düğme pasif kalır).
 */
export function useReportExport(source: PmsSource, vesselId: string | null) {
  const { i18n } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const run = useCallback(
    async (reportId: PmsReportId, format: PmsReportFormat, query: PmsReportFilter = {}) => {
      if (!source.exportReport || !vesselId) return;
      setBusy(true);
      setFailed(false);
      try {
        await source.exportReport(vesselId, reportId, {
          format,
          lang: i18n.language?.startsWith('tr') ? 'tr' : 'en',
          query,
        });
      } catch {
        setFailed(true);
      } finally {
        setBusy(false);
      }
    },
    [source, vesselId, i18n.language],
  );
  return {
    available: Boolean(source.exportReport) && vesselId !== null,
    busy,
    failed,
    dismiss: () => setFailed(false),
    run,
  };
}
